import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Appearance.css';

const Appearance = () => {
  const [ref, inView] = useInView({
    threshold: 0.15,
    triggerOnce: true,
  });

  return (
    <section className="appearance" id="appearance" ref={ref}>
      <div className="appearance-container">
        <motion.div
          className="appearance-visual"
          initial={{ opacity: 0, x: -40 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <img
            src="/images/faces.png"
            alt="Примеры внешности цифровых аватаров"
            className="appearance-image"
          />
        </motion.div>

        <motion.div
          className="appearance-content"
          initial={{ opacity: 0, x: 40 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <h2 className="section-title appearance-title">Любая внешность и голос</h2>
          <p className="appearance-text">
            Мы бесплатно создадим любую внешность с идеальным сходством и даже можем оживить вашего талисмана.
          </p>
          <p className="appearance-text">
            А ещё — полное брендирование интерфейса и библиотека голосов.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Appearance;
